export default "/images/AysunGüngör.jpg?db6c842dbc6e0cb54469821fedd621a3";